// @core/api/endpoints/workflow/create_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTestCaseRequest,
  TestCaseResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create test case
 * Creates a test case with trigger data, node mocks, and assertions for DRY_RUN execution.
 */
export async function CreateTestCase(
  pipeline_id: string,
  data: CreateTestCaseRequest,
  options?: RequestOptions
): Promise<TestCaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/test-cases`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<TestCaseResponse>(requestPath, data, requestOptions);
}
